import { Component, OnInit, OnDestroy, effect } from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder } from '@angular/forms';
import { distinctUntilChanged } from 'rxjs'; 
import { map, debounceTime } from 'rxjs/operators';

import { DirectSessionLogicService } from '../../../../shared/direct-session-logic.service';
import { ItemFormat } from '../../../../shared/models/itemFormat.model';
import { GoogleService } from '../../../../shared/google.service';
import { uspsData } from '../../../../shared/models/uspsData';
import { standardizedAddress } from '../../../../shared/models/standardizedAddress';
import { environment } from '../../../../../environments/environment';
import { CustomerFormat } from '../../../../shared/models/customerFormat.model';


@Component({
  selector: 'app-form-contact-confirmation',
  template: `
  <section>
    <div class="your-info-card">
        <div class="your-info-header">
          <h5 class="your-info-title">Your Information</h5>
          <div class="edit-label" (click)="GoToEditPage()" clickable>Edit <img src="assets/Icons/edit-pencil.svg" alt="edit"></div>
        </div>

        <div class="row">
          <div class="col-md-6 info-cell">
            <div class="info-label">Name</div>
            <div class="info-value">{{firstName}} {{lastName}}</div>
          </div>
          <div class="col-md-6 info-cell">
            <div class="info-label">ZIP Code</div>
            <div class="info-value">{{zipCode}}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 info-cell">
            <div class="info-label">Address</div>
            <div class="info-value">{{address}}</div>
          </div>
          <div class="col-md-6 info-cell">
            <div class="info-label">Phone Number</div>
            <div class="info-value">{{phone}}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 info-cell">
            <div class="info-label">City, State</div>
            <div class="info-value">{{city}}, {{state}}</div>
          </div>
          <div class="col-md-6 info-cell">
            <div class="info-label">Email Address</div>
            <div class="info-value">{{email}}</div>
          </div>
        </div>
    </div>

  </section>
  `,
  styleUrls: ['./form-contact-confirmation.component.scss'],
  standalone: true,
  imports: [ 
    ReactiveFormsModule
  ]
})
export class FormContactInfoConfirmationComponent {
  
  contactForm: FormGroup = new FormGroup({});

  get selections(): ItemFormat[] {
    return this.directSessionLogic.cartItemsSignal();
  }

  firstName: string = '';
  lastName: string = '';
  email: string = '';
  phone: string = '';
  address: string = '';
  city: string = '';
  state: string = '';
  zipCode: string = '';
  country: string = '';

  isAddressVerified:boolean = false; // set using this.setAddressValidationStatus(bool)
  isAddressComplete:boolean = false; // 
  uspsData:uspsData | any = {};
  enteredAddress = {} as standardizedAddress;
  verifiedAddress = {} as standardizedAddress;


  companyName: string = "";
  contactPermissionMessage: string = "we may contact you if you click next";

  nameRegex: RegExp = /^[a-zA-Z\-]+$/;
  phoneRegex: RegExp = /^([0-9]{3})[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  zipCodeRegex: RegExp = /[0-9]{5}/;
  emailRegex: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/;

  //list of all valid two character state IDs

  constructor(
    public directSessionLogic: DirectSessionLogicService,
    private builder: FormBuilder,
    public googleService: GoogleService
  ) {
    this.escapeCheck();

    this.getSessionInfo();
    this.getConfigData();
  }

  //Add on exit function to save form data to session
  //ONLY if customer has a name and either (email or phone number)

  getSessionInfo() {
    let customer = this.directSessionLogic.customerSignal();

    if(customer.firstName != undefined || customer.firstName != null){
      this.firstName = customer.firstName;
      this.lastName = customer.lastName;
      this.email = customer.email;
      this.phone = this.parseOutPhoneNumber(customer.phoneNumber);
      this.address = customer.address;
      this.city = customer.city;
      this.state = customer.state;
      this.zipCode = customer.zip;
      this.country = customer.country;
    }
  }

  async getConfigData(){
    this.companyName = environment.CompanyInfo.CompanyName.toString();
    
    this.contactPermissionMessage = environment.LegalData.find( data => 
      data.legalRef == "contact"
      )?.legalText || "error getting contact permission message for $$company$$";

    this.contactPermissionMessage = this.contactPermissionMessage.replace(
      "$_$", this.companyName
    );
  }

  parseOutPhoneNumber(phone: string): string{
    if (!phone) {
      return '';
    }

    // Remove non-numeric characters
    let parsedPhone = phone.replace(/[^0-9]/g, '');

    // Drop a leading US country code so 11-digit numbers still format
    if (parsedPhone.length === 11 && parsedPhone.startsWith('1')) {
      parsedPhone = parsedPhone.slice(1);
    }

    // Format standard 10-digit US numbers
    if (parsedPhone.length === 10) {
      parsedPhone = `(${parsedPhone.slice(0, 3)}) ${parsedPhone.slice(3, 6)}-${parsedPhone.slice(6)}`;
    }

    // Anything else (e.g. an out-of-range 12-digit entry) is returned as raw digits
    return parsedPhone;
  }


  GoToEditPage(){
    //have this section call the navigate to page function navControls
    let canMoveToEdit = this.directSessionLogic.changingStepSignal(0);

    if(canMoveToEdit){
      console.log("returning to conact page");
      this.directSessionLogic.unCompleteStepAfter(0);

      let navUrl = this.directSessionLogic.getStepAtIndexSignal(0).reference;
      this.directSessionLogic.redirectToStepSignal(navUrl);
    }
  }  


  escapeCheck(){
    if(this.directSessionLogic.planSelectedSignal().name === undefined || this.directSessionLogic.planSelectedSignal().name === null) {
      console.log("no plan selected, escaping to top level");
      this.directSessionLogic.escapeToTopLevelSignal();
    }else{
      console.log("plan selected, continuing");
      this.directSessionLogic.completeCurrentPage();
    }
  }
}


  

